import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import LoadContentSpinner from '../../components/Utils/LoadContentSpinner';
import { buildEventBookingUrl } from '../../config/billetterie';
import Error404 from '../Error404';

const EVENT_UUID =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Anciennes URLs vitrine → 301/replace vers la billetterie Laravel. */
export default function LegacyBookingRedirect() {
    const { eventId } = useParams();
    const valid = Boolean(eventId && EVENT_UUID.test(eventId));

    useEffect(() => {
        if (!valid) return;
        window.location.replace(buildEventBookingUrl(encodeURIComponent(eventId)));
    }, [eventId, valid]);

    if (!valid) {
        return <Error404 />;
    }

    return <LoadContentSpinner fullScreen />;
}
